// src/components/tour/tours/sitesMap.jsx
//
// Sites Map tour (internal admins). ctx is registered in AdminSitesMap.jsx.

import React from 'react';
import { replayStep } from './common';

const Dot = ({ color }) => (
    <span style={{ display: 'inline-block', width: 9, height: 9, borderRadius: 999, background: color, verticalAlign: 'middle', margin: '0 2px 2px' }} />
);

export function getSitesMapSteps(ctx, env) {
    const { siteCount = 0, placedCount = 0, unplacedCount = 0, counts = {} } = ctx;
    const click = env.isMobile ? 'Tap' : 'Click';

    return [
        {
            target: null,
            title: 'Welcome to the Sites Map',
            content: (
                <p>
                    Every site with a known position, on one map:{' '}
                    <span className="pt-data">{placedCount}</span> of <span className="pt-data">{siteCount}</span> sites are placed.
                    The position comes from the site's Peplink GPS, or its Starlink when the Peplink has no fix.
                </p>
            ),
        },
        {
            target: '[data-tour="map-toolbar"]',
            title: 'Find & filter',
            content: (
                <p>
                    Search a site by name (a single match opens its popup straight away), or show only sites
                    needing <b>ATTENTION</b> or fully <b>DOWN</b>.
                </p>
            ),
        },
        {
            target: '[data-tour="map-map"]',
            title: 'The map',
            content: (
                <>
                    <p>
                        One marker per site, coloured by state. The small <b>P</b> or <b>S</b> on a marker says whether
                        its position came from Peplink or Starlink.
                    </p>
                    <p>
                        {click} a marker for the nearest place, when the position was last reported, and{' '}
                        <b>OPEN SITE →</b> to jump to it on the Site Dashboard.
                    </p>
                </>
            ),
        },
        {
            target: '[data-tour="map-legend"]',
            title: 'Colours',
            content: (
                <p>
                    <Dot color="#88F4EB" /> online (<span className="pt-data">{counts.online ?? 0}</span>),{' '}
                    <Dot color="#CAFB6D" /> some devices offline (<span className="pt-data">{counts.attention ?? 0}</span>),{' '}
                    <Dot color="#fff" /> every device offline (<span className="pt-data">{counts.down ?? 0}</span>).
                </p>
            ),
        },
        {
            target: '[data-tour="map-unplaced"]',
            title: 'Not placed',
            content: (
                <p>
                    {unplacedCount > 0
                        ? <><span className="pt-data">{unplacedCount}</span> site{unplacedCount === 1 ? ' has' : 's have'} no position yet.</>
                        : 'Sites with no position would appear here.'}{' '}
                    Assign a device with a GPS fix to the site in Site Manager (<b>ASSIGN →</b>) to put it on the map.
                </p>
            ),
        },
        replayStep,
    ];
}
